import { useCallback } from 'react';
import some from 'lodash/some';
import {
  PermissionLevels,
  PoliciesPermissionSetItems as Permission,
} from 'common/constants/permissions';
import { IUserProfileInfo } from 'modules/authentication/interfaces';
import { selectCurrentUser } from 'modules/authentication/state/selectors';
import useRootSelector from 'common/hooks/useRootSelector';

export default function useClubPermissionChecker() {
  const user: IUserProfileInfo = useRootSelector(selectCurrentUser)?.toJS();

  return useCallback(
    (clubId: string, permission: Permission): boolean => {
      const roles = user?.securityRoles || [];

      for (const role of roles) {
        if (role.securityRole.level === PermissionLevels.CORPORATE) {
          for (const policy of role.securityRole.securityPolicyDtoSet) {
            if (policy.permissionSet.includes(permission)) {
              return true;
            }
          }
        }

        if (role.securityRole.level === PermissionLevels.CLIENT) {
          const hasClub = some(role.clubList, item => item.id === clubId);

          if (hasClub) {
            for (const policy of role.securityRole.securityPolicyDtoSet) {
              if (policy.permissionSet.includes(permission)) {
                return true;
              }
            }
          }
        }
      }

      return false;
    },
    [user],
  );
}
